<template>
  <div class="modal fade" id="subscriptionSettingsModal" tabindex="-1" aria-labelledby="subscriptionSettingsModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="subscriptionSettingsModalLabel">Configurações Gerais de Assinatura</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <form @submit.prevent="saveConfiguration" class="form">
          <div class="modal-body">
            <!-- Nav tabs -->
            <ul class="nav nav-tabs nav-line-tabs mb-5 fs-6">
              <li class="nav-item">
                <a class="nav-link active" data-bs-toggle="tab" href="#tab-notification">
                  <i class="bi bi-bell me-2"></i>Notificações
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" data-bs-toggle="tab" href="#tab-installments">
                  <i class="bi bi-calculator me-2"></i>Cartão de crédito
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" data-bs-toggle="tab" href="#tab-billing">
                  <i class="bi bi-credit-card me-2"></i>Cobrança
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" data-bs-toggle="tab" href="#tab-bank-slip">
                  <i class="bi bi-bank me-2"></i>Boleto
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" data-bs-toggle="tab" href="#tab-nfse">
                  <i class="bi bi-receipt me-2"></i>NFSe
                </a>
              </li>
            </ul>

            <!-- Tab panes -->
            <div class="tab-content">
              <!-- Notification Tab -->
              <div class="tab-pane fade show active" id="tab-notification" role="tabpanel">
                <div class="row mb-5">
                  <div class="col-md-6">
                    <label for="days_before_due" class="required form-label">Dias antes do vencimento</label>
                    <input
                      type="number"
                      class="form-control form-control-solid"
                      id="days_before_due"
                      :class="errors.days_before_due ? 'is-invalid' : ''"
                      name="days_before_due"
                      v-model.number="form.days_before_due"
                      min="1"
                      max="30"
                      required
                      placeholder="Ex: 5"
                    />
                    <div class="form-text">Número de dias antes do vencimento para enviar a notificação (1-30 dias)</div>
                    <div class="fv-plugins-message-container invalid-feedback" v-if="errors.days_before_due">
                      {{ errors.days_before_due.join('\n') }}
                    </div>
                  </div>

                  <div class="col-md-6">
                    <label for="notification_methods" class="required form-label">Métodos de notificação</label>
                    <select
                      v-model="form.notification_methods"
                      class="form-control form-control-solid"
                      id="notification_methods"
                      :class="errors.notification_methods ? 'is-invalid' : ''"
                      name="notification_methods"
                      required
                    >
                      <option value="email">Apenas E-mail</option>
                      <option value="whatsapp">Apenas WhatsApp</option>
                      <option value="both">E-mail e WhatsApp</option>
                    </select>
                    <div class="form-text">Escolha como os assinantes receberão as notificações de cobrança</div>
                    <div class="fv-plugins-message-container invalid-feedback" v-if="errors.notification_methods">
                      {{ errors.notification_methods.join('\n') }}
                    </div>
                  </div>
                </div>

                <div class="row mb-5">
                  <div class="col-md-12">
                    <div class="alert alert-info d-flex align-items-center p-5">
                      <i class="bi bi-info-circle fs-2hx text-info me-4"></i>
                      <div class="d-flex flex-column">
                        <h4 class="mb-1 text-info">Notificações</h4>
                        <span>As notificações incluirão um botão de extrato para facilitar a visualização pelos assinantes.</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row mb-5" v-if="form.notification_methods === 'whatsapp' || form.notification_methods === 'both'">
                  <div class="col-md-12">
                    <div class="alert alert-warning d-flex align-items-center p-5">
                      <i class="bi bi-exclamation-triangle fs-2hx text-warning me-4"></i>
                      <div class="d-flex flex-column">
                        <h4 class="mb-1 text-warning">Cobrança WhatsApp</h4>
                        <span>As notificações via WhatsApp estão sujeitas a cobrança por mensagem, conforme tabela vigente da Meta.</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Installments Tab -->
              <div class="tab-pane fade" id="tab-installments" role="tabpanel">
                <div class="row mb-5">
                  <div class="col-md-6">
                    <label for="max_installments_without_interest" class="required form-label">Parcelas sem juros</label>
                    <input
                      type="number"
                      class="form-control form-control-solid"
                      id="max_installments_without_interest"
                      :class="errors.max_installments_without_interest ? 'is-invalid' : ''"
                      name="max_installments_without_interest"
                      v-model.number="form.max_installments_without_interest"
                      min="1"
                      max="12"
                      required
                      placeholder="Ex: 2"
                      @input="updateCalculationExample"
                    />
                    <div class="form-text">Número máximo de parcelas sem juros (1-12)</div>
                    <div class="fv-plugins-message-container invalid-feedback" v-if="errors.max_installments_without_interest">
                      {{ errors.max_installments_without_interest.join('\n') }}
                    </div>
                  </div>

                  <div class="col-md-6">
                    <label for="interest_percent_per_installment" class="required form-label">Percentual de juros (%)</label>
                    <input
                      type="number"
                      class="form-control form-control-solid"
                      id="interest_percent_per_installment"
                      :class="errors.interest_percent_per_installment ? 'is-invalid' : ''"
                      name="interest_percent_per_installment"
                      v-model.number="form.interest_percent_per_installment"
                      min="0"
                      max="10"
                      step="0.01"
                      required
                      placeholder="Ex: 1.99"
                      @input="updateCalculationExample"
                    />
                    <div class="form-text">Percentual de juros aplicado por parcela (0-10%)</div>
                    <div class="fv-plugins-message-container invalid-feedback" v-if="errors.interest_percent_per_installment">
                      {{ errors.interest_percent_per_installment.join('\n') }}
                    </div>
                  </div>
                </div>

                <div class="row mb-5">
                  <div class="col-md-12">
                    <div class="alert alert-success d-flex align-items-center p-5">
                      <i class="bi bi-calculator fs-2hx text-success me-4"></i>
                      <div class="d-flex flex-column">
                        <h4 class="mb-1 text-success">Exemplo de Cálculo</h4>
                        <span v-if="calculationExample.length === 0">Configure os valores acima para ver um exemplo.</span>
                        <div v-else>
                          <p class="mb-2"><strong>Valor total: R$ {{ exampleTotal.toFixed(2) }}</strong></p>
                          <ul class="mb-0">
                            <li v-for="calc in calculationExample" :key="calc.installment">
                              {{ calc.description }} - Total: R$ {{ calc.total.toFixed(2) }}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Billing Tab -->
              <div class="tab-pane fade" id="tab-billing" role="tabpanel">
                <div class="row mb-5">
                  <div class="col-md-12">
                    <label for="billing_mode" class="required form-label">Modo de cobrança das assinaturas</label>
                    <select
                      class="form-select form-select-solid"
                      id="billing_mode"
                      :class="errors.billing_mode ? 'is-invalid' : ''"
                      name="billing_mode"
                      v-model="form.billing_mode"
                      required
                    >
                      <option value="upfront">Tudo de uma vez</option>
                      <option value="monthly">Mensal</option>
                    </select>
                    <div class="form-text">
                      <strong>Tudo de uma vez:</strong> Cliente paga o valor total do plano na assinatura<br>
                      <strong>Mensal:</strong> Cliente paga apenas a primeira parcela, sistema cobra mensalmente as demais parcelas.
                    </div>
                    <div class="fv-plugins-message-container invalid-feedback" v-if="errors.billing_mode">
                      {{ errors.billing_mode.join('\n') }}
                    </div>
                  </div>
                </div>

                <div class="row mb-5">
                  <div class="col-md-12">
                    <label class="form-label">Métodos de pagamento no checkout da assinatura</label>
                    <div
                      class="border rounded p-3"
                      :class="errors['checkout_payment_methods'] ? 'border-danger' : 'border-secondary'"
                    >
                      <div class="row row-cols-1 row-cols-md-3 g-4 g-md-3 align-items-center">
                        <div class="col">
                          <div class="form-check form-switch">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              id="checkout_payment_credit_card"
                              :class="{ 'is-invalid': errors['checkout_payment_methods'] }"
                              :checked="form.checkout_payment_methods.includes('credit_card')"
                              @change="setCheckoutPaymentMethod('credit_card', $event.target.checked)"
                            />
                            <label class="form-check-label" for="checkout_payment_credit_card">
                              Cartão de crédito
                            </label>
                          </div>
                        </div>
                        <div class="col">
                          <div class="form-check form-switch">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              id="checkout_payment_bank_slip"
                              :class="{ 'is-invalid': errors['checkout_payment_methods'] }"
                              :checked="form.checkout_payment_methods.includes('bank_slip')"
                              @change="setCheckoutPaymentMethod('bank_slip', $event.target.checked)"
                            />
                            <label class="form-check-label" for="checkout_payment_bank_slip">
                              Boleto
                            </label>
                          </div>
                        </div>
                        <div class="col">
                          <div class="form-check form-switch">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              id="checkout_payment_pix"
                              :class="{ 'is-invalid': errors['checkout_payment_methods'] }"
                              :checked="form.checkout_payment_methods.includes('pix')"
                              @change="setCheckoutPaymentMethod('pix', $event.target.checked)"
                            />
                            <label class="form-check-label" for="checkout_payment_pix">
                              Pix
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-text">
                      Métodos de pagamento para cobranças realizadas pelo checkout de assinatura. Pelo menos um deve permanecer selecionado.
                    </div>
                    <div class="fv-plugins-message-container invalid-feedback d-block" v-if="errors['checkout_payment_methods']">
                      {{ Array.isArray(errors['checkout_payment_methods']) ? errors['checkout_payment_methods'].join('\n') : errors['checkout_payment_methods'] }}
                    </div>
                  </div>
                </div>

                <div class="row mb-5">
                  <div class="col-md-6">
                    <label for="retry_attempts_max" class="required form-label">Tentativas de cobrança</label>
                    <input
                      type="number"
                      class="form-control form-control-solid"
                      id="retry_attempts_max"
                      :class="errors.retry_attempts_max ? 'is-invalid' : ''"
                      name="retry_attempts_max"
                      v-model.number="form.retry_attempts_max"
                      min="1"
                      max="5"
                      required
                      placeholder="Ex: 3"
                    />
                    <div class="form-text">Número máximo de tentativas de cobrança por parcela (1-5)</div>
                    <div class="fv-plugins-message-container invalid-feedback" v-if="errors.retry_attempts_max">
                      {{ errors.retry_attempts_max.join('\n') }}
                    </div>
                  </div>

                  <div class="col-md-6">
                    <label for="suspension_after_consecutive_failures" class="required form-label">Suspensão após</label>
                    <input
                      type="number"
                      class="form-control form-control-solid"
                      id="suspension_after_consecutive_failures"
                      :class="errors.suspension_after_consecutive_failures ? 'is-invalid' : ''"
                      name="suspension_after_consecutive_failures"
                      v-model.number="form.suspension_after_consecutive_failures"
                      min="1"
                      max="5"
                      required
                      placeholder="Ex: 2"
                    />
                    <div class="form-text">Suspender assinatura após quantas parcelas consecutivas não pagas (1-5)</div>
                    <div class="fv-plugins-message-container invalid-feedback" v-if="errors.suspension_after_consecutive_failures">
                      {{ errors.suspension_after_consecutive_failures.join('\n') }}
                    </div>
                  </div>
                </div>

                <div class="row mb-5">
                  <div class="col-md-6">
                    <label for="grace_period_days" class="required form-label">Período de carência</label>
                    <input
                      type="number"
                      class="form-control form-control-solid"
                      id="grace_period_days"
                      :class="errors.grace_period_days ? 'is-invalid' : ''"
                      name="grace_period_days"
                      v-model.number="form.grace_period_days"
                      min="0"
                      max="30"
                      required
                      placeholder="Ex: 7"
                    />
                    <div class="form-text">Dias extras após vencimento antes de suspender (0-30)</div>
                    <div class="fv-plugins-message-container invalid-feedback" v-if="errors.grace_period_days">
                      {{ errors.grace_period_days.join('\n') }}
                    </div>
                  </div>
                </div>
              </div>

              <!-- Bank-slip Tab -->
              <div class="tab-pane fade" id="tab-bank-slip" role="tabpanel">
                <div class="row mb-5">
                  <div class="col-md-6">
                    <label for="penalty_amount" class="required form-label">Multa por atraso (%)</label>
                    <input
                        type="number"
                        class="form-control form-control-solid"
                        id="penalty_amount"
                        :class="errors.penalty_amount ? 'is-invalid' : ''"
                        name="interest_percent_per_installment"
                        v-model.number="form.penalty_amount"
                        min="0"
                        max="10"
                        step="0.01"
                        required
                        placeholder="Ex: 1.00"
                    />
                    <div class="form-text">Multa por atraso (0-100%)</div>
                    <div class="fv-plugins-message-container invalid-feedback" v-if="errors.penalty_amount">
                      {{ errors.penalty_amount.join('\n') }}
                    </div>
                  </div>

                  <div class="col-md-6">
                    <label for="interest_amount" class="required form-label">Percentual de juros (mes)</label>
                    <input
                        type="number"
                        class="form-control form-control-solid"
                        id="interest_amount"
                        :class="errors.interest_amount ? 'is-invalid' : ''"
                        name="interest_percent_per_installment"
                        v-model.number="form.interest_amount"
                        min="0"
                        max="10"
                        step="0.01"
                        required
                        placeholder="Ex: 1.00"
                    />
                    <div class="form-text">Percentual de juros por atraso (0-100%)</div>
                    <div class="fv-plugins-message-container invalid-feedback" v-if="errors.interest_amount">
                      {{ errors.interest_amount.join('\n') }}
                    </div>
                  </div>
                </div>

                <div class="row mb-5">
                  <div class="col-md-12">
                    <label for="bank_slip_instruction" class="form-label">Instrução do Boleto</label>
                    <textarea
                      class="form-control form-control-solid"
                      id="bank_slip_instruction"
                      :class="errors.bank_slip_instruction ? 'is-invalid' : ''"
                      name="bank_slip_instruction"
                      v-model="form.bank_slip_instruction"
                      rows="4"
                      placeholder="Ex: Não receber após o vencimento. Em caso de dúvidas, entre em contato."
                    ></textarea>
                    <div class="form-text">Instrução que será exibida no boleto. Esta mensagem será adicionada às mensagens padrão do boleto.</div>
                    <div class="fv-plugins-message-container invalid-feedback" v-if="errors.bank_slip_instruction">
                      {{ errors.bank_slip_instruction.join('\n') }}
                    </div>
                  </div>
                </div>
              </div>

              <!-- NFSe Tab -->
              <div class="tab-pane fade" id="tab-nfse" role="tabpanel">
                <div class="row mb-5">
                  <div class="col-md-12">
                    <div class="form-check form-switch form-check-custom form-check-solid">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="emit_nfse_per_company_charge"
                        v-model="form.emit_nfse_per_company_charge"
                      />
                      <label class="form-check-label fw-semibold" for="emit_nfse_per_company_charge">
                        Emitir NFSe para cada cobrança da assinatura (cobranças empresariais)
                      </label>
                    </div>
                    <div class="form-text">Quando ativo, uma NFSe será emitida para cada cobrança mensal das empresas (fechamento).</div>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-light" data-bs-dismiss="modal" @click="resetForm" :disabled="loading">
              Cancelar
            </button>
            <button type="submit" class="btn btn-primary" :disabled="loading">
              <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              {{ loading ? 'Salvando...' : 'Salvar Configurações' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/helpers/http";
import Alert from "@/helpers/alert";
import Modal from "@/helpers/modal";

export default {
  name: "SubscriptionSettings",
  data() {
    return {
      loading: false,
      errors: {},
      calculationExample: [],
      exampleTotal: 100.00,
      form: {
        days_before_due: 3,
        notification_methods: 'email',
        max_installments_without_interest: 2,
        interest_percent_per_installment: 1.99,
        billing_mode: 'upfront',
        retry_attempts_max: 3,
        suspension_after_consecutive_failures: 2,
        grace_period_days: 7,
        penalty_amount: 2.0,
        interst_amount: 1.0,
        bank_slip_instruction: null,
        emit_nfse_per_company_charge: false,
        checkout_payment_methods: ['credit_card', 'bank_slip', 'pix'],
      },
      originalForm: {
        days_before_due: 3,
        notification_methods: 'email',
        max_installments_without_interest: 2,
        interest_percent_per_installment: 1.99,
        billing_mode: 'upfront',
        retry_attempts_max: 3,
        suspension_after_consecutive_failures: 2,
        grace_period_days: 7,
        penalty_amount: 2.0,
        interst_amount: 1.0,
        bank_slip_instruction: null,
        emit_nfse_per_company_charge: false,
        checkout_payment_methods: ['credit_card', 'bank_slip', 'pix'],
      }
    };
  },
  computed: {
    place() {
      return this.$store.state.auth.place;
    }
  },
  mounted() {
    this.loadConfiguration();
  },
  methods: {
    normalizeCheckoutPaymentMethods(value) {
      const allowed = ['credit_card', 'bank_slip', 'pix'];
      if (!Array.isArray(value) || value.length === 0) {
        return [...allowed];
      }
      const filtered = allowed.filter((m) => value.includes(m));
      return filtered.length > 0 ? filtered : [...allowed];
    },

    setCheckoutPaymentMethod(method, enabled) {
      const next = [...this.form.checkout_payment_methods];
      if (enabled) {
        if (!next.includes(method)) {
          next.push(method);
        }
      } else {
        if (next.length <= 1) {
          return;
        }
        const idx = next.indexOf(method);
        if (idx !== -1) {
          next.splice(idx, 1);
        }
      }
      this.form.checkout_payment_methods = next;
    },

    async loadConfiguration() {
      try {
        this.loading = true;
        const response = await http.get(`/places/${this.place.id_place}/subscription-config`);

        this.form = {
          days_before_due: response.data.days_before_due || 3,
          notification_methods: response.data.notification_methods || 'email',
          max_installments_without_interest: response.data.max_installments_without_interest || 2,
          interest_percent_per_installment: response.data.interest_percent_per_installment || 1.99,
          billing_mode: response.data.billing_mode || 'upfront',
          retry_attempts_max: response.data.retry_attempts_max || 3,
          suspension_after_consecutive_failures: response.data.suspension_after_consecutive_failures || 2,
          grace_period_days: response.data.grace_period_days || 7,
          penalty_amount: response.data.penalty_amount || 2,
          interest_amount: response.data.interest_amount || 1,
          bank_slip_instruction: response.data.bank_slip_instruction || null,
          emit_nfse_per_company_charge: response.data.emit_nfse_per_company_charge || false,
          checkout_payment_methods: this.normalizeCheckoutPaymentMethods(response.data.checkout_payment_methods),
        };

        this.originalForm = { ...this.form };
        this.updateCalculationExample();

      } catch (error) {
        console.error('Erro ao carregar configuração:', error);
        Alert.error('Erro ao carregar as configurações.');
      } finally {
        this.loading = false;
      }
    },

    async saveConfiguration() {
      try {
        this.loading = true;
        this.errors = {};

        const payload = {
          id_place: this.place.id_place,
          days_before_due: this.form.days_before_due,
          notification_methods: this.form.notification_methods,
          max_installments_without_interest: this.form.max_installments_without_interest,
          interest_percent_per_installment: this.form.interest_percent_per_installment,
          billing_mode: this.form.billing_mode,
          retry_attempts_max: this.form.retry_attempts_max,
          suspension_after_consecutive_failures: this.form.suspension_after_consecutive_failures,
          grace_period_days: this.form.grace_period_days,
          penalty_amount: this.form.penalty_amount,
          interest_amount: this.form.interest_amount,
          bank_slip_instruction: this.form.bank_slip_instruction,
          emit_nfse_per_company_charge: this.form.emit_nfse_per_company_charge,
          checkout_payment_methods: this.form.checkout_payment_methods,
        };

        await http.post(`/places/${this.place.id_place}/subscription-config`, payload);

        Alert.success('Configuração salva com sucesso.');

        this.originalForm = { ...this.form };

        // Fechar o modal após salvar
        Modal.toggle('#subscriptionSettingsModal');
        
      } catch (error) {
        if (error.response?.data?.errors) {
          this.errors = error.response.data.errors;
        } else {
          Alert.error(error.response?.data?.message || 'Erro ao salvar a configuração.');
        }
      } finally {
        this.loading = false;
      }
    },

    resetForm() {
      this.form = { ...this.originalForm };
      this.errors = {};
      this.updateCalculationExample();
    },

    updateCalculationExample() {
      if (this.form.max_installments_without_interest && this.form.interest_percent_per_installment >= 0) {
        // Simulate installment calculation
        const maxWithoutInterest = this.form.max_installments_without_interest;
        const interestPercent = this.form.interest_percent_per_installment;

        this.calculationExample = [];

        for (let i = 1; i <= 6; i++) { // Show first 6 installments as example
          if (i <= maxWithoutInterest) {
            const value = this.exampleTotal / i;
            this.calculationExample.push({
              installment: i,
              description: i === 1 ? "à vista" : `${i} x de R$ ${value.toFixed(2)} sem juros`,
              total: this.exampleTotal
            });
          } else {
            const interestRate = interestPercent / 100;
            const value = this.exampleTotal * Math.pow(1 + interestRate, i) / i;
            const totalValue = value * i;
            this.calculationExample.push({
              installment: i,
              description: `${i} x de R$ ${value.toFixed(2)} com juros`,
              total: totalValue
            });
          }
        }
      } else {
        this.calculationExample = [];
      }
    },
  }
}
</script>

<style scoped>
.spinner-border-sm {
  width: 1rem;
  height: 1rem;
}
</style>